export default {
  setloginError(state, payload) {
    state.loginerror = payload
  },

  setAuditLogByDay(state, payload) {
    state.auditlog = payload
  },
  setDeposits(state, payload) {
    state.sitedeposits = payload
  },
  setManualDeposits(state, payload) {
    state.manualdeposits = payload
  },
  setsitePickups(state, payload) {
    state.pickups = payload
  },
  setFISiteList(state, payload) {
    state.mlinstdata = payload
  },
  setFISiteAnalysis (state, payload) {
    state.aidataAnalysis = payload
  },
  setSeqFeedData (state, payload) {
    state.seqfeeddata = payload
  },
  setPingsList (state,payload) {
    state.pinglist = payload
  },
  setSeqDataPublished (state, payload) {
    state.seqDataPublished = payload
  },
  setFeedData (state, payload) {
    state.feedData = payload
  },
  setSSFeedData (state, payload) {
    state.feedSSData = payload
  },
  setVaultAIData (state, payload) {
    state.aivaultdata = payload
  },
  setVaultAIContext(state, payload) {
    state.aivaultcontext = payload
  },
  setmlresults(state, payload) {
    state.mlresults = payload
  },
  setWeather(state, payload) {
    state.weatherdata = payload
  },
  setPickupSchedule(state, payload) {
    state.pickupdata = payload
    console.log('schedule set to ', state.pickupdata)
  },
  setJamEventList(state, payload) {
    state.notereaderjamlist = payload
  },
  setAllPickupSchedules(state, payload) {
    state.allpickupschedules = payload
  },
  setstackerevents(state, payload) {
    state.stackerevents = payload
  },
  setJamEvents(state, payload) {
    state.notereaderjams = payload
  },
  setSystemEvents(state, payload) {
    state.systemevents = payload
  },
  setNotereaderEventList(state, payload) {
    state.notereadereventlist = payload
  },
  setNotereaderEvents(state, payload) {
    state.notereaderevents = payload
  },
  setheartbeatvalues(state, payload) {
    console.log('setting heart beats ', payload)
    state.heartbeatvalues = payload
  },
  setUserDeposits(state, payload) {
    state.userdeposits = payload
  },
  setLoadedDepositusers(state, payload) {
    state.depositusers = payload
  },
  setLoadedChangeOrders(state, payload) {
    state.changeorders = payload
  },
  setLoadedFilledChangeOrders(state, payload) {
    state.filledorders = payload
  },
  setLoadedChangeSchedules(state, payload) {
    console.log('mut change schedules ', payload)
    state.changeschedules = payload
  },
  setTotalCash(state, payload) {
    state.dailytotals = payload
  },
  setSystemSnap(state, payload) {
    state.systemsnap = payload
  },
  setPostalPackages(state, payload) {
    state.packages = payload
  },
  setEstateNoteCount(state, payload) {
    state.estatenotecount = payload
  },
  setCITValues(state, payload) {
    console.log('cit ', payload)
    state.citevents = payload
  },
  setgrosspostaldeposits(state, payload) {
    state.grosspostaldeposits = payload
  },
  setgrossvalidated(state, payload) {
    state.grossvalidated = payload
  },
  setgrosssumbyday(state, payload) {
    state.grosssumbyday = payload
  },
  setpostalchecks(state, payload) {
    state.postalchecks = payload
  },
  setLoadedChangeProfiles(state, payload) {
    state.changeprofiles = payload
  },
  setLoadedBillingClients(state, payload) {
    state.billingclients = payload
  },
  setLoadedBillingProfiles(state, payload) {
    console.log('profiles ', payload)
    state.billingprofiles = payload
  },
  setLoadedBillingConfig(state, payload) {
    state.billingconfigs = payload
  },
  setLoadedPostalDeposits(state, payload) {
    state.postaldeposits = payload
  },
  setLoadedPostalBags(state, payload) {
    state.postalbags = payload
  },
  setPostShipments(state, payload) {
    console.log('postal shipments set to ', payload)
    state.postalshipments = payload
  },
  setLoadedSecureBagDeposits(state, payload) {
    state.securebag = payload
  },
  setCashinValues(state, payload) {
    state.sitecashinvalues = ''
    state.sitecashinvalues = payload
  },
  setGroupShipments(state, payload) {
    state.GroupShipments = payload
  },
  setCashinGroupValues(state, payload) {
    state.cashingroupvalues = payload
  },
  setLoadedReleases(state, payload) {
    state.rels = payload
  },
  setCITGroupValues(state, payload) {
    state.groupcitvalues = payload
  },
  setGroupPickups(state, payload) {
    state.grouppickups = payload
    console.log('pickup set ', state.grouppickups)
  },
  setUserInstitutions(state, payload) {
    state.userinstitutions = payload
  },
  setLoadedUnits(state, payload) {
    state.ssunits = payload
  },
  setSplitData(state, payload) {
    state.splitdata = payload
  },
  appendUserDeposits(state, payload) {
    console.log('new entry timestmap ', payload.timestamp)
    let dup = state.userdeposits.find(entry => entry.timestamp === payload.timestamp)
    console.log('*** REAL TIME DUP STATUS ', dup, payload)
    if (!dup) {
      state.userdeposits.push(payload)
      console.log('appending, no dup ')
    }
  },
  appendCit(state, payload) {
    console.log('adding cit live was ', state.citevents, ' push ', payload)

    state.citevents.push(payload)
    //  state.userdeposits = payload
  },
  appendManualDeposits(state, payload) {
    state.manualdeposits.push(payload)
  },
  setCashBalanceValues(state, payload) {
    state.sitebalancevalues = ''
    state.sitebalancevalues = payload
  },
  setError(state, payload) {
    if (payload.message) {
      state.error = payload.message
    } else {
      state.error = payload
    }
  },
  setLoadedProfiles(state, payload) {
    state.siteprofiles = payload
  },
  setSystemData(state, payload) {
    state.systemdata = payload
  },
  setsafestatus(state, payload) {
    state.safes = payload
  },
  setEstatesums(state, payload) {
    state.estatesums = payload
  },
  setCashConnectSites(state, payload) {
    state.ccsites = payload
  },
  setKapchargeSites(state, payload) {
    state.kcsites = payload
  },
  setNamsysSites(state, payload) {
    state.nssites = payload
    console.log('nssites', state.nssites)
  },
  setNamsysTransactionDetail (state, payload) {
    state.transactionDetail = payload
  },
  setSafeandSoundSites(state, payload) {
    state.sssites = payload
  },
  setSafeFobs(state, payload) {
    state.keyfobs = payload
  },
  setLoadedAlerts(state, payload) {
    state.alerts = payload
  },
  setLoadedSites(state, payload) {
    state.loadedSites = payload
    state.sites = payload
  },
  setUserGroups(state, payload) {
    state.usergroups = payload
  },
  clearError(state) {
    state.error = null
  },

  setUser(state, payload) {
    state.user = payload
  },

  setLoadedUserProfiles(state, payload) {
    state.userprofiles = [...payload]
  },
  setDimebankSite(state, payload) {
    state.isDimebankSite = payload
  },
  setChaseAEGSite(state, payload) {
    state.isChaseAEGSite = payload
  },
  setLoading(state, payload) {
    state.isloading = payload
  },
  setCheckedPackages(state, payload) {
    state.checkedPackages = payload
  },
  setShipmentDetail(state, payload) {
    state.shipmentDetail = payload
  },
  setAllPackageTrackingNumbers(state, payload) {
    state.allPackageTrackingNumbers = payload
  },
  setCheckedDetail(state, payload) {
    state.checkedDetail = payload
  },
  setFIEODs(state, payload) {
    state.fieods = payload
  },
}
